import React from 'react';
import CategorymastersHeader from '../CategorymastersHeader';
import CategorymastersContent from '../CategorymastersContent';

const Categorymasters = () => {
    return (
        <>
            <CategorymastersHeader />
            <CategorymastersContent />
        </>
    );
};

export default Categorymasters;
